<template>
    <div class="edit-options-wrap" :class="isFixed?'':'no-fixed'" @click.self="returnBack">
        <div class="return-btns" @click="returnBack" v-if="isFixed"><img src="../assets/img/mob_return.png"/></div>
        <div class="btns-box">
            <div class="lists" v-for="(item,index) in options" :key="index" @click="onclick(item)">
                <img :src="item.src"/>
                <h5>{{item.title}}</h5>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "EditOptions",
        props:{
            options:{
                type: Array,
                default: ()=>[]
            },
            isFixed:{
                type: Boolean,
                default: true
            }
        },
        methods:{
            returnBack(){
                this.$emit('returnBack')
            },
            onclick(item){
                this.$emit('onclick',item.type)
            }
        }
    }
</script>

<style lang="less" scoped>
    .edit-options-wrap{
        &.no-fixed{
            position: inherit;
            /*background-color: #0e0e0e;*/
            background-color: #333;
            height: 80px;
            .btns-box{
                height: 80px;
            }
        }
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background-color: #000000;
        height: 62px;

        .return-btns{
            position: absolute;
            left: 16px;
            top: 9px;
            width: 44px;
            height: 44px;
            background-color: #323232;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            &>img{
                width: 20px;
                height: 20px;
            }
        }
        .btns-box{
            display: flex;
            justify-content: center;
            align-items: center;
            .lists{
                height: 62px;
                margin: 0 12px;
                padding-top: 14px;
                text-align: center;
                h5{
                    color: #c7c7c7;
                    font-size: 12px;
                    user-select:none;
                }
                img{
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }

</style>
